import { useValidationContext } from "@features/mx/validations/context";
import { useSearchParams } from "react-router-dom";
import ExemptionsList from "./ExemptionsList";
import ValidationDetailsView from "../../shared/ValidationDetailsView";
function ExemptionsLanding() {
  const { viewMode, readingId, validatorId } = useValidationContext();
  return viewMode === "detail" ? (
    <ValidationDetailsView readingId={readingId} />
  ) : (
    <ExemptionsList />
  );
}

export default ExemptionsLanding;
